module.exports = __webpack_public_path__ + "static/a-family-of-titan-scholars-image-2-800x533-52f11bd018652dacce12fbad2786b88a.jpg";